import { nanoid } from "nanoid";
import AppConstants from "../constants/AppConstants";
import BlockConverter from "./BlockConverter";

/**
 * Duplicates a site block/canvas to a page block/canvas
 * @param {Object} pageBlock - The page block to duplicate to
 * @param {Object} siteBlock - The site block to duplicate from
 * @returns {Object} The duplicated block
 */
const duplicateSiteCanvasAsPageCanvas = (pageBlock, siteBlock) => {
    const pageBlockJS = pageBlock.toJS();
    const siteBlockJS = siteBlock.toJS();
    const newPageCanvas = BlockConverter.toPageBlock(pageBlockJS, siteBlockJS);
    newPageCanvas.id = nanoid(AppConstants.ID_LENGTH);
    return newPageCanvas;
}

export default {
    duplicateSiteCanvasAsPageCanvas
}